import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppAnimate from "../../components/AppAnimate";
import {withSnackbar} from "notistack";
import {Styles} from "../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import {Translate} from "../../../config/Translate";
import {withRouter} from "react-router";
import 'shikwasa/dist/style.css';
import axios from "axios";
import {defaultVariabls} from "../../../config";
import EBookReader from "./EBookReader";
import ReaderLoader from "./components/ReaderLoader";
import PDFBookReader from "./PDFBookReader";

class PlayerPage extends React.Component {
    constructor(props) {
        super(props)
        this.viewerRef = React.createRef()
    }
    state = {
        id:this.props.match.params.id,
        loading:true,
        fullscreen:true,
        book:null,
        current_episode:null,
        location:0,
    };
    classes = this.props.classes;

    componentDidMount() {
        this.loadData();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/library/get-ebook/${this.state.id}`, config)
                .then(async response => {
                    await this.setState({
                        book:response.data,
                    })
                    await this.setState({
                        loading:false,

                    })
                }).catch(error => {
                    console.log(error.response)
                    this.props.history.push('/library')
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }

    render(){
        let {book,loading,location,fullscreen} = this.state;

        return (
            <div className={this.classes.readerContainer}>
                <div className={fullscreen ? "reader-parent fullscreen" : "reader-parent" }>
                    <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.viewBook}>
                        <>
                            {
                                !loading ?
                                    <>
                                        {
                                            book.product.book_file.extension === "pdf" ?
                                                <PDFBookReader
                                                    book={book}
                                                    url={`${defaultVariabls.website}/file/get-ebook/${book.product.book_file.id}.pdf?token=${book.product.book_file.token}`}
                                                    title={book.product.name}
                                                />
                                                :
                                                <EBookReader
                                                    book={book}
                                                    url={`${defaultVariabls.website}/file/get-ebook/${book.product.book_file.id}.epub`}
                                                    title={book.product.name}
                                                />
                                        }

                                    </>

                                :
                                <ReaderLoader/>

                            }
                        </>

                    </AppAnimate>
                </div>
            </div>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(PlayerPage))));